import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  output,
  Signal,
  TrackByFunction,
  viewChild
} from '@angular/core';
import {
  NguCarousel,
  NguCarouselConfig,
  NguCarouselDefDirective,
  NguCarouselNextDirective,
  NguCarouselPrevDirective,
  NguTileComponent
} from '@ngu/carousel';
import {Image, WineProduct} from '@core/interfaces/generated/graphql';
import {NgOptimizedImage} from '@angular/common';
import {StoryblokService} from '@core/services/storyblok.service';
import {ProductImage} from '@modules/page/components/product/components/product-image/product-images.component';
import {ArrowCircleDownIconComponent} from '@core/svg-icons/360-image-icon.component';

@Component({
  selector: 'app-product-image-thumbnail-carousel',
  templateUrl: './product-image-thumbnail-carousel.component.html',
  styleUrls: ['./product-image-thumbnail-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, NguTileComponent, NguCarouselDefDirective, NguCarouselPrevDirective, NguCarouselNextDirective, NguCarousel, ArrowCircleDownIconComponent]
})
export class ProductImageThumbnailCarouselComponent {
  storyblokService = inject(StoryblokService);


  readonly activeImageIdChange = output<any>();
  readonly carousel = viewChild<NguCarousel<WineProduct['images']>>('carousel');

  public carouselTile: NguCarouselConfig = {
    grid: {
      xs: 3, sm: 3, md: 3, lg: 3, all: 0
    },
    point: {
      visible: true
    },
    load: 3,
    velocity: 0,
    touch: true,
    easing: 'cubic-bezier(0, 0, 0.2, 1)'
  };

  public showNavigationButtons: Signal<boolean> = computed(() => (this.images()?.length ?? 0) > 3)

  images = input<ProductImage[] | null>(null);
  activeImageId = input<string | null>(null);

  constructor() {
    effect(() => {
      const images = this.images();
      if (!images) {
        return;
      }
      const currentActiveImageId = this.activeImageId();
      const activeImageIndex = images.findIndex(image => image?.id === currentActiveImageId);
      if (activeImageIndex && activeImageIndex !== -1) {
        this.carousel()?.moveTo(activeImageIndex + 1);
      }
    });
  }


  onClick(item: Image): void {
    if (!item) {
      return;
    }
    this.activeImageIdChange.emit(item?.id ?? '');
  }

  trackBy(): TrackByFunction<WineProduct> {
    return (index, item) => {
      return item?.id;
    };
  }
}
